import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {PHONE_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_PHONE_INPUT_TYPE = 'postermywall-phone-input';

export const POSTERMYWALL_PHONE_INPUT: AddComponentTypeOptions = createBaseInputComponent({
  inputFieldType: POSTERMYWALL_PHONE_INPUT_TYPE,
  inputName: 'phone',
  dataMarkerAttribute: 'data-is-pmw-form-phone-input',
  displayName: 'Phone',
  placeholder: 'Enter your phone number here',
  style: PHONE_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-phone-input') !== null,
  additionalAttributes: {type: 'tel'},
});
